import { Helmet } from "react-helmet"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/case-study/laqshya/thumb.png"

export function Index() {
  return (
    <Layout
      title="How Laqshya scaled a premium check-in experience with 800+ AI avatar badges"
      description="Every event marketer knows that first impressions matter. For an event marketing agency like Laqshya Live Experiences, ensuring that first moment felt premium was essential for the Aditya Birla Group."
      metaImage={ThumbnailImage}
      keywords={[""]}
      noIndex
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "Laqshya Live Experiences", url: "/case-study/laqshya-live-experiences/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "How Laqshya scaled a premium check-in experience with 800+ AI avatar badges",
            "description": "Every event marketer knows that first impressions matter. For an event marketing agency like Laqshya Live Experiences, ensuring that first moment felt premium was essential for the Aditya Birla Group.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-06-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.LAQSHYA} />
    </Layout>
  )
}

export default Index
